export const READER_MODE_OFF :number= 0;
export const READER_MODE_RFID :number= 1;
export const READER_MODE_BARCODE :number= 2;
export const READER_MODE_BOTH :number= 3;

export const READER_SCAN_SINGLE :number= 1;
export const READER_SCAN_MULTIPLE :number= 2;
export const READER_SCAN_GEIGER :number= 3;


export const CODE_READER_CONNECT: number = 200;
export const CODE_READER_IS_CONNECTED: number = 202;


/**
 * Bluetooth controller Request codes
 */
export const CODE_BLUETOOTH_DEVICE_TURN_ON : number=100;
export const CODE_BLUETOOTH_DEVICE_TURN_OFF : number=101;
export const CODE_BLUETOOTH_DEVICE_LIST : number=102;
export const CODE_BLUETOOTH_PAIR_NEW_DEVICES : number=103;

export const CODE_READER_DISCONNECT : number=201;

export const CODE_READER_SET_CONFIG : number=203; // Thing config
export const CODE_READER_GET_CONFIG : number=204; // Get thing config

export const CODE_READER_SET_SCAN : number=205; // single, multiple, geiger // power
export const CODE_READER_GET_SCAN : number=206;

export const CODE_READER_SET_MODE : number=207;
export const CODE_READER_GET_MODE : number=208;//rfid, barcode, both => Geiger 1: RFID, 2: Barcode

export const CODE_READER_PULL : number=209; //true, false / timer ? null : default

export const CODE_READER_SET_SOUND : number=210;
export const CODE_READER_GET_SOUND : number=211;

export const CODE_READER_SET_VIBRATE : number=212;
export const CODE_READER_GET_VIBRATE : number=213;

export const CODE_READER_CLEAR_CACHE : number=216;
export const CODE_READER_CLEAR : number=217;


export const CODE_RESPONSE_DEFAULT : number=400; //BaseResponse.class
export const CODE_RESPONSE_BLUETOOTH_STATUS : number=401; //BluetoothStateResponse.class
export const CODE_RESPONSE_BLUETOOTH_DEVICES : number=402; //BluetoothResponse.class
export const CODE_RESPONSE_READER_STATE : number=403; //ReaderStateResponse.class
export const CODE_RESPONSE_THING_CONFIGURATION : number=404; //ThingConfigurationResponse.class
export const CODE_RESPONSE_READER_CONFIGURATION : number=405; //ReaderConfiguration.class
export const CODE_RESPONSE_READER_TRIGGER : number=406; //TriggerResponse.class
export const CODE_RESPONSE_READER_READ : number=407; //ReadResponse.class



export const DEVICE_BARCODE_DEFAULT_CODE : number=800;




// WEBPACK FOOTER //
// ./src/providers/reader.constants.ts